var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_451_1262",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_451_1262",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD2klEQVR4nO2dSY9NURDHf4mhW0xb3S1B8AUMK4QItlggMQWNDYkp7VnaGVbSia9hXBA+ABHSho0NNobQupsVkubIkSK89H3p1ufcqntf/ZLa3Lz3UvV/N+fUqVvnXHAcx3Ecx3Ecx3HGzRRgJdALXASuAU+BF8Aw8E1sWK49lc9ckO+skN9wxmA+cBy4CXwGwiTtE3ADOAb00ObMAPYAd4HvCcQtslHgDrAb6KSNmCV32puM4hbZB+AsMJcaMw3oA4YUBG626MMp8alWrAGeGRC42Z4DG6gBcUy8DPwwIGqRRd/6gQ4qykLgvgEhwzjtEbCEirEhUZoWSraYFq6nImwFvhgQLfynxcXQDoxzOHNOHEqyGMMhjLJFFgfaIoWEYm/HGHFc+2pAnJBhGNmEEZZWdOILE5ggF2uL3CFpUai5PdTOsy8bECGUZHFRo7astrziC4ktxrq2bJGnAk8MBB9KtmdlF6L6lDKAPqBL7LRcK9uPE2WJPFup1Hl6DF8aCn4MSk09OxrBBbmLm5mn5EusZWcve75VCq4IDV/eyaO4bOxVCiy08EnLn505hY4PUl1ofmlwK5fIPcpFoyI0i05ZWhmOKwYVWvil6dPRHELH5hYXmn80uJJa5NhiNeJC03yjjaRuP1upfDeHFr5p+7U8pdAHDQRUhLZf+0nIRQMBFaHt1zkSct1AQEWEOk2IFkqiRWj7NUBCXmUodWqRusT6MqVzHzOWOrVoJCybJiPVv9+FHVKVWGObhTmhu7FDj0WhUw0dDexwxuLQkXIybCjf2d3ig8nJ0NM7yknvfMFCOQsWX4JTzhK8N9F4FiZhRWj7tS+l0F4mpVDoZSmF9sI/5RT+kb3VPnSQbyL8TdxW7ELzjwZHciX63m7AH5FHpV6ShXhKgGcd5G2gQY59cKHJ3xLWqXT8Q2jhUy2bHLWa0ENBISpVqXOidpIaN6I3MpY6J1oWnUlJnFII8NtfJdbUpc6JWExzS90s9FghyNBum4Uiq337W3n0G7jLQkl2CUU6ZPtuqLk9AKajzGLZmB5qaiPAIoywruKnzoQCi1nNRoyxuYYHo2zDKIdqctTPqPSEm2ZLxYeRrxaP+Gl19M+nik5866gYC4B7BsQL47SHFo70mUye3W98BflDFiPqeXKq5foTA6I2W/RpFTVjqhwqMmhA4EGpwkWfastMCfK1gsDv5aDuObQRncAu4Hbmhc6oPEjd2W5Hz49Fl2xgvypvo5isuMPyW0dytgRUnSnSz3YAOC/dQAPyKpChv14PMiTXBuQz52UXa/yuvx7EcRzHcRzHcRyHcfITiV5ZbaaGSxIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.c0cb60b529c02aed598e0e14e41518fc.svg";
export { ForwardRef as ReactComponent };